import { FC, SVGAttributes } from 'react';
import { colors } from '@shared/tokens/colors.stylex';

interface XmarkIconProps extends SVGAttributes<SVGElement> {
  onClick?: () => void;
  size?: string;
  color?: string;
}

export const XmarkIcon: FC<XmarkIconProps> = ({ onClick, size = '16', color = colors.secondaryIcon, ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      cursor="pointer"
      onClick={onClick}
      {...props}
    >
      <g id="Icons/x-mark(cross)">
        <path
          id="Vector (Stroke)"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.64645 3.64645C3.84171 3.45118 4.15829 3.45118 4.35355 3.64645L8 7.29289L11.6464 3.64645C11.8417 3.45118 12.1583 3.45118 12.3536 3.64645C12.5488 3.84171 12.5488 4.15829 12.3536 4.35355L8.70711 8L12.3536 11.6464C12.5488 11.8417 12.5488 12.1583 12.3536 12.3536C12.1583 12.5488 11.8417 12.5488 11.6464 12.3536L8 8.70711L4.35355 12.3536C4.15829 12.5488 3.84171 12.5488 3.64645 12.3536C3.45118 12.1583 3.45118 11.8417 3.64645 11.6464L7.29289 8L3.64645 4.35355C3.45118 4.15829 3.45118 3.84171 3.64645 3.64645Z"
        />
      </g>
    </svg>
  );
};
